import { List, ListSubheader } from "@mui/material";
import { ActorDemandadoList } from "components/electronicFile/components/portadas/components/actorDemandadoList";
import { Promovente } from "interfaces/solicitudFirma/solicitudFirmaInterface";

interface PartesPromocionPropsInterface {
  promoventes: Promovente[] | null;
}

export const PartesPromocion = ({
  promoventes,
}: PartesPromocionPropsInterface) => {
  return (
    <List
      dense={true}
      subheader={<ListSubheader component="div">Promovente(s)</ListSubheader>}
    >
      {promoventes &&
        promoventes.map((promovente, key: number) => {
          return (
            <ActorDemandadoList
              nombre={
                 promovente.nombrePersonaMoral
              }
              key={key}
            />
          );
        })}
    </List>
  );
};
